import api from '@/libs/axiosInstance';
import type { ApiResponse, BulkEmailBatchResponse } from '@fluenceur/types';
import { queryOptions, useQuery } from '@tanstack/react-query';

const BULK_EMAIL_STATUS_POLL_INTERVAL_MS = 5_000;

export const bulkEmailBatchStatusQueryKey = (brandId: string, batchId: string) =>
  ['bulk-email-batch-status', brandId, batchId] as const;

export const fetchBulkEmailBatchStatus = async (
  batchId: string
): Promise<BulkEmailBatchResponse> => {
  const { data } = await api.get<ApiResponse<BulkEmailBatchResponse>>(
    `/dashboard/affiliates/bulk-email/${batchId}`
  );

  if (!data.success || !data.data) {
    throw new Error(data.message || 'Failed to fetch bulk email batch status');
  }

  return data.data;
};

export const bulkEmailBatchStatusQueryOptions = (brandId: string, batchId: string) =>
  queryOptions({
    queryKey: bulkEmailBatchStatusQueryKey(brandId, batchId),
    queryFn: () => fetchBulkEmailBatchStatus(batchId),
    staleTime: 0,
  });

export const useBulkEmailBatchStatusQuery = (
  brandId: string | null | undefined,
  batchId: string | null,
  isProcessing: boolean
) =>
  useQuery({
    ...bulkEmailBatchStatusQueryOptions(brandId ?? '', batchId ?? ''),
    enabled: !!brandId && !!batchId && isProcessing,
    refetchInterval: isProcessing ? BULK_EMAIL_STATUS_POLL_INTERVAL_MS : false,
  });
